var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWnPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 11.9854V14.1104C15.5843 14.3077 15.5439 14.5029 15.4649 14.6837C15.3858 14.8644 15.2699 15.0267 15.1246 15.16C14.9792 15.2934 14.8076 15.3949 14.6207 15.4581C14.4338 15.5213 14.2358 15.5448 14.0393 15.5271C11.8597 15.2902 9.76597 14.5454 7.92643 13.3525C6.21497 12.2649 4.76396 10.8139 3.67643 9.10248C2.47933 7.25458 1.73435 5.15068 1.50184 2.96123C1.48414 2.76535 1.50742 2.56793 1.5702 2.38154C1.63297 2.19516 1.73387 2.02388 1.86647 1.87863C1.99907 1.73337 2.16045 1.61731 2.34036 1.53785C2.52027 1.45838 2.71475 1.41725 2.91143 1.41706H5.03643C5.38019 1.41368 5.71345 1.53541 5.97409 1.75956C6.23474 1.98372 6.40498 2.295 6.45309 2.63539C6.54278 3.31544 6.70912 3.98316 6.94893 4.62581C7.04423 4.87934 7.06485 5.15487 7.00836 5.41977C6.95187 5.68466 6.82062 5.92781 6.63018 6.12039L5.73059 7.01998C6.73894 8.79332 8.20725 10.2616 9.98059 11.27L10.8802 10.3704C11.0728 10.1799 11.3159 10.0487 11.5808 9.99221C11.8457 9.93572 12.1212 9.95634 12.3748 10.0516C13.0174 10.2914 13.6851 10.4578 14.3652 10.5475C14.7093 10.596 15.0235 10.7693 15.2481 11.0345C15.4728 11.2996 15.5921 11.638 15.5835 11.9854Z",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnPhone);
export default __webpack_public_path__ + "static/media/wn-phone.c98d4a4856ea4ba188da16e28246ebf7.svg";
export { ForwardRef as ReactComponent };